import { render, staticRenderFns } from "./income.vue?vue&type=template&id=09944e78&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=09944e78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09944e78",
  null
  
)

export default component.exports